export const upsertSearchParams = (
  { url, key, value }: { url: string; key: string; value: string },
  opt?: { preventThrowError?: boolean },
) => {
  try {
    const newUrl = new URL(url)
    newUrl.searchParams.set(key, value)
    return newUrl.toString()
  } catch (error) {
    if (!opt?.preventThrowError) {
      throw error
    }
    return url
  }
}

export const upsertTimestampToUrl = (url: string, opt?: { preventThrowError?: boolean }) =>
  upsertSearchParams({ url, key: 'ts', value: Date.now() + '' }, opt)
